export default __webpack_public_path__ + "static/media/error.1a23556b.svg";